<mat-toolbar color="primary">
    <mat-toolbar-row fxLayout="row">
        <span class="title-center">Change Password</span>
    </mat-toolbar-row>
</mat-toolbar>

<mat-dialog-content>
    <form [formGroup]="changePasswordForm">
        <div fxFlex fxLayout="column">

            <mat-form-field appearance="fill" fxFlex>
                <mat-label>Old Password</mat-label>
                <input matInput formControlName="oldPassword" type="password" required>
                <mat-error
                    *ngIf="changePasswordForm.controls.oldPassword.touched && changePasswordForm.controls.oldPassword.invalid">
                    <span *ngIf="changePasswordForm.controls.oldPassword.error.required">This field is mandatory.</span>
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" fxFlex>
                <mat-label>New Password</mat-label>
                <input matInput formControlName="newPassword" type="password" required>
                <mat-error
                    *ngIf="changePasswordForm.controls.newPassword.touched && changePasswordForm.controls.newPassword.invalid">
                    <span *ngIf="changePasswordForm.controls.newPassword.error.required">This field is mandatory.</span>
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" fxFlex>
                <mat-label>Confirm Password</mat-label>
                <input matInput formControlName="confirmPassword" type="password" required>
                <mat-error
                    *ngIf="changePasswordForm.controls.confirmPassword.touched && changePasswordForm.controls.confirmPassword.invalid">
                    <span *ngIf="changePasswordForm.controls.confirmPassword.error.required">This field is
                        mandatory.</span>
                </mat-error>
                <mat-hint *ngIf="validateSubmit() && !(changePasswordForm.controls.confirmPassword.invalid)">
                    <span>Confirm Password doesn't match with New Password</span>
                </mat-hint>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="center">
    <button mat-raised-button color="primary" type="submit" (click)="handleChangePasswordSubmit()"
        [disabled]="validateSubmit() || !(changePasswordForm.valid && changePasswordForm.dirty)">Change</button>
    <button mat-raised-button color="primary" mat-dialog-close>Close</button>
</mat-dialog-actions>